import MenuAPI from '../../../utils/menuAPI';
import actionCreators from './actionCreators';

const fetchMenuData = () => async dispatch => {
    dispatch(actionCreators.requestMenuData());

    try {
        const data = await MenuAPI.fetchMenuData();
        dispatch(actionCreators.menuDataResponse(true, data, null))
    } catch (error) {
        dispatch(actionCreators.menuDataResponse(false, [], error))
    }
};

export default {
    fetchMenuData
}
